module.exports = __webpack_public_path__ + "img/no-pedestrians.768c2b73.png";